<template>
  <div class="admin-list">
    <Row>
      <Col :xs="24" :sm="24">
        <Form :inline="true">
          <FormItem>
            <Button @click="showArea()" type="success" class="f-r">选择区域</Button>
          </FormItem>
        </Form>
      </Col>
    </Row>
    <Table border :columns="list" ref="roleList" :data="tablelist" :loading="dataloading"></Table>
    <div style="margin: 10px;overflow: hidden">
      <div style="float: right;">
        <Page
          ref="listPage"
          :total="pages.total"
          :current="pages.page"
          :page-size="pages.size"
          show-elevator
          show-total
          @on-change="changePage()"
        ></Page>
      </div>
    </div>
    <!--设置数量-->
    <Modal v-model="showEditInfoStatus" title="设置" @on-ok="updateAdmin()" :loading="loading">
      <Form :model="adminInfo" :label-width="150">
        <FormItem label="假数据：" label-position="top">
          <Input v-model="adminInfo.false_num"></Input>
        </FormItem>
      </Form>
    </Modal>
    <!-- 区域 -->
    <Modal v-model="showAreaStatus" title="管理区域" @on-ok="updateArea()" :loading="loading">
      <Form :model="adminarea" action="javascript:void(0)">
        <FormItem>
          <Select v-model="adminarea.area1" multiple placeholder="省" @on-change="shengChange">
            <Option v-for="item in shengList" :value="item.id" :key="item.id">{{item.areaname}}</Option>
          </Select>
        </FormItem>
        <FormItem>
          <Select v-model="adminarea.area2" multiple placeholder="市" @on-change="shiChange">
            <Option v-for="item in shiList" :value="item.id" :key="item.id">{{item.areaname}}</Option>
          </Select>
        </FormItem>
        <FormItem>
          <Select v-model="adminarea.area3" multiple placeholder="县">
            <Option v-for="item in quList" :value="item.id" :key="item.id">{{item.areaname}}</Option>
          </Select>
        </FormItem>
      </Form>
    </Modal>
  </div>
</template>

<script>
export default {
  name: "admin-list",
  data() {
    return {
      loading: true,
      dataloading: true,
      admin_id: 0,
      formItem: {
        key: ""
      },
      pages: {
        page: 1,
        size: 10
      },
      list: [
        {
          title: "Id",
          key: "id",
          width: 80,
          fixed: "left"
        },
        {
          title: "省市区",
          Width: 120,
          key: "areaname"
        },
        {
          title: "统计数据",
          width: 100,
          key: "false_num"
        },
        {
          title: "操作",
          key: "action",
          fixed: "right",
          width: 600,
          align: "left",
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  style: {
                    marginRight: "8px"
                  },
                  props: {
                    type: "primary",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.showEditInfo(params.row.id);
                    }
                  }
                },
                "设置数据"
              ),
              h(
                "Button",
                {
                  props: {
                    type: "error",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.remove(params.index, params.row.id);
                    }
                  }
                },
                "删除"
              )
            ]);
          }
        }
      ],
      tablelist: [],
      roleList: [],
      sectionList: [],
      shengList: [],
      shiList: [],
      quList: [],
      adminInfo: {
        false_num: 0
      },
      adminarea: {},
      showEditInfoStatus: false,
      showAreaStatus: false,
      role_ids: []
    };
  },
  created: function() {
    // 取数据
    this.getTableList();
    this.getShengList();
  },
  methods: {
    getTableList: function() {
      this.$api.bigmap.getHeatArea().then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          this.tablelist = res.result.list;
          this.pages.total = res.result.total;
          this.$Message.success(res.msg);
        }
      });
      return;
    },
    // 展开修改
    showEditInfo(value) {
      this.hot_id = value;
      this.adminInfo = {
        false_num: 0
      };
      this.showEditInfoStatus = !this.showEditInfoStatus;
      // 取信息
      this.$api.bigmap.getHeatAreaDetail({ hot_id: value }).then(res => {
        if (res.code == 200) {
          this.adminInfo = res.result;
          this.$Message.success(res.msg);
        }
        this.loading = false;
        this.$nextTick(() => {
          this.loading = true;
        });
      });
    },
    // 更新假数据
    updateAdmin: function(name) {
      this.$api.bigmap
        .postHeatAreaNum({
          hot_id: this.hot_id,
          false_num: this.adminInfo.false_num
        })
        .then(res => {
          if (res.code == 200) {
            this.$Message.success(res.msg);
            this.showEditInfoStatus = !this.showEditInfoStatus;
            this.renderTable(1);
          }
          this.loading = false;
          this.$nextTick(() => {
            this.loading = true;
          });
        });
    },
    //区域
    showArea(value) {
      this.showAreaStatus = !this.showAreaStatus;
    },
    getShengList() {
      this.$api.intangibleItem.areaList({ id: 0 }).then(res => {
        if (res.code == 200) {
          this.shengList = res.result;
        }
      });
    },
    shengChange(value) {
      if (value != undefined) {
        this.$api.intangibleItem.secondarea({ id: value }).then(res => {
          if (res.code == 200) {
            this.shiList = res.result;
          }
        });
      }
    },
    shiChange(value) {
      if (value != undefined) {
        this.$api.intangibleItem.secondarea({ id: value }).then(res => {
          if (res.code == 200) {
            this.quList = res.result;
          }
        });
      }
    },

    //更新区域
    updateArea: function(index) {
      console.log("adminarea:" + this.adminarea);
      this.$api.bigmap.postHeatArea({ adminarea: this.adminarea }).then(res => {
        if (res.code == 200) {
          this.showAreaStatus = false;
          this.$Message.success(res.msg);
          this.getTableList();
        }
      });
    },
    // 删除
    remove: function(index, id) {
      // 弹出确认框
      this.$Modal.confirm({
        title: "警告",
        content: "<p>此操作不可恢复，三思而后行...</p>",
        onOk: () => {
          this.$api.bigmap.removeHeatArea({ hot_id: id }).then(res => {
            if (res.code == 200) {
              this.$Message.success(res.msg);
              this.renderTable(1);
            }
          });
        }
      });
    },
    // 翻页
    changePage() {
      this.pages.page = this.$refs["listPage"].currentPage;
      this.renderTable(1);
    },
    // 筛选
    renderTable: function(name) {
      if (name != 1) {
        this.pages.page = 1;
      }
      this.dataloading = true;
      var ps = {
        page: this.pages.page,
        size: this.pages.size
      };
      this.$api.bigmap.getHeatArea(ps).then(res => {
        if (res.code == 200) {
          this.tablelist = res.result.list;
          this.pages.total = res.result.total;
          this.$Message.success(res.msg);
        }
        this.dataloading = false;
      });
      return;
    }
  }
};
</script>
